import React, {useState, useEffect} from 'react';
import {assets} from '../../utils/assetsSrc';
import './sidebar.scss';
import {NavLink, useNavigate} from 'react-router-dom';
import {useDispatch} from 'react-redux';
import {logout} from '../../redux/login/loginSlice';
import {allRoutes} from '../../utils/routeConstants';
import {Modal} from 'react-bootstrap';
import Button from '../form/button/button';
import {useSelector} from 'react-redux';
import {getLoginStateSelector} from '../../redux/selectors/loginSelector';
import {sideBarTabsNoAccess} from '../../utils/constants';
import {Tooltip} from '@mui/material';
import VersionTooltip from '../version-tooltip/version-tooltip';

const navItemsMainArr = [
  {
    id: 'assessment',
    name: 'Risk Assessments',
    icon: assets.sideNavList,
    navigationTo: allRoutes.dashboardRoutes.assessment,
  },
  {
    id: 'feedback',
    name: 'Feedback',
    icon: assets.sideNavList,
    navigationTo: allRoutes.feedback,
  },
  { 
    id: 'powerbi', 
    name: 'Dashboard', 
    icon: assets.sideNavList, 
    navigationTo: allRoutes.dashboardRoutes.powerBi,
  },
];

const navItemsManageArr = [
  {
    id: 'userlist',
    name: 'User List',
    icon: assets.sideNavList,
    navigationTo: allRoutes.dashboardRoutes.userList.main,
  },
//   {
//     id: 'changePassword',
//     name: 'Change Password',
//     icon: assets.sideNavList,
//     navigationTo: allRoutes.dashboardRoutes.changePassword,
//   },
  {
    id: 'deleted',
    name: 'Deleted Risk Assessments',
    icon: assets.sideNavList,
    navigationTo: allRoutes.dashboardRoutes.deletedAssessment,
  },
];

export default function Sidebar({onToggle}) {
  const nav = useNavigate();
  const dispatch = useDispatch();
  const loginState = useSelector(getLoginStateSelector);
  const [isCollapsed, setIsCollapsed] = useState(() => {
    const storedState = localStorage.getItem('sidebarCollapsed');
    return storedState ? JSON.parse(storedState) : false;
  });
  const [logoutConfirm, setLogoutConfirm] = useState(false);
  const [navItemsManage, setNavItemsManage] = useState(navItemsManageArr);
  const [navItemsMain, setNavItemsMain] = useState(navItemsMainArr);

  useEffect(() => {
    const filteredManageTabs = loginState?.loggedInUser?.role
      ? navItemsManageArr.filter(
          tab =>
            !sideBarTabsNoAccess[loginState.loggedInUser.role].includes(tab.id),
        )
      : navItemsManageArr;
    setNavItemsManage(filteredManageTabs);
  }, [loginState]);

  useEffect(() => {
    localStorage.setItem('sidebarCollapsed', JSON.stringify(isCollapsed));
    onToggle(isCollapsed);
  }, [isCollapsed, onToggle]);

  const handleToggleSidebar = () => {
    setIsCollapsed(!isCollapsed);
  };

  const handleLogout = () => {
    dispatch(logout());
    setTimeout(() => {
      localStorage.clear();
    }, 1000);
    nav('/home');
  };

  return (
    <div className={`sidebar-wrapper ${isCollapsed ? 'collapsed' : ''}`}>
      <div className="sidebar-nav">
        <nav>
          <ul className="sidebar-nav-items">
            {navItemsMain.map(listItem => (
              <li key={listItem.id}>
                <NavLink
                  style={{display: 'flex', alignItems: 'center'}}
                  className={navData => (navData.isActive ? 'active' : 'link')}
                  to={listItem.navigationTo}
                  data-tooltip={listItem.name} // Added title for hover text
                >
                  <span>
                    <img src={listItem.icon} alt={listItem.name} />
                  </span>
                  <span className={`name ${isCollapsed ? 'hidden' : ''}`}>
                    {listItem.name}
                  </span>
                </NavLink>
              </li>
            ))}
            <div className="sidebar-heading">Manage</div>
            {navItemsManage.map(listItem => (
              <li key={listItem.id}>
                <NavLink
                  style={{display: 'flex', alignItems: 'center'}}
                  className={navData => (navData.isActive ? 'active' : 'link')}
                  to={listItem.navigationTo}
                  data-tooltip={listItem.name} // Added title for hover text
                >
                  <span>
                    <img src={listItem.icon} alt={listItem.name} />
                  </span>
                  <span className={`name ${isCollapsed ? 'hidden' : ''}`}>
                    {listItem.name}
                  </span>
                </NavLink>
              </li>
            ))}
          </ul>
        </nav>
      </div>

      <div className="logout-icon">
        <span
          className="logout-button"
          onClick={() => setLogoutConfirm(true)}
          title="Logout">
          {' '}
          {/* Added title here too */}
          <span className="material-symbols-outlined">logout</span>
          {/*<span className='logout-icon-image'><img src={assets.logout} alt="Logout" /></span>*/}
          <span className={`name ${isCollapsed ? 'hidden' : ''}`}>Logout</span>
        </span>
      </div>
      <div className="sidebar-footer">
        <button
          className="sidebar-toggle-button"
          onClick={handleToggleSidebar}
          title={isCollapsed ? 'Expand Sidebar' : 'Collapse Sidebar'}>
          {' '}
          {/* Tooltip for toggle button */}
          <span className="material-symbols-sharp">
            {isCollapsed ? 'left_panel_open' : 'left_panel_close'}
          </span>
        </button>

       <VersionTooltip/>
      </div>

      <Modal
        show={logoutConfirm}
        onHide={() => setLogoutConfirm(false)}
        aria-labelledby="confirm-logout"
        centered
        className="confirm-logout-modal">
        <Modal.Body className="p-5 px-5 text-center">
          <div className="header">
            <p className="label mt-3 mb-4">{'Confirm Logout'}</p>
          </div>
          <div className="main-text">Are you sure, you want to logout?</div>
          <div className="action-buttons">
            <Button
              type="button"
              variant="submit-button"
              clickHandler={() => setLogoutConfirm(false)}>
              Cancel
            </Button>
            <Button
              type="button"
              variant="secondary-button"
              clickHandler={handleLogout}>
              Confirm
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}
